import React, { useState } from "react"

interface CpmAimModalProps {
  isOpen: boolean
  onClose: () => void
  brandId: string
  currentValue?: number
  onSave: (brandId: string, cpmAim: number) => Promise<void>
}

const CpmAimModal: React.FC<CpmAimModalProps> = ({
  isOpen,
  onClose,
  brandId,
  currentValue,
  onSave,
}) => {
  const [cpmAim, setCpmAim] = useState<number>(currentValue || 0)
  const [isLoading, setIsLoading] = useState(false)

  const handleSave = async () => {
    setIsLoading(true)
    try {
      await onSave(brandId, cpmAim)
      onClose()
    } catch (error) {
      console.error("Error saving CPM Aim:", error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault()
      handleSave()
    }
  }

  if (!isOpen) {
    return null
  }

  return (
    <div className="fixed right-0 top-0 h-full z-50">
      <div className="bg-white h-full w-96 shadow-lg flex flex-col">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-4">
          <div className="flex justify-between items-start">
            <div>
              <h2 className="text-xl font-semibold">CPM Aim Düzenle</h2>
              <p className="text-sm opacity-90 mt-1">Marka ID: {brandId}</p>
            </div>
            <button onClick={onClose} className="text-white hover:text-gray-200">
              ×
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 p-4 overflow-y-auto">
          <div className="mb-4">
            <label htmlFor="cpmAim" className="block text-sm font-medium text-gray-700 mb-2">
              CPM Aim
            </label>
            <input
              type="number"
              id="cpmAim"
              value={cpmAim}
              onChange={(e) => setCpmAim(Number(e.target.value))}
              onKeyPress={handleKeyPress}
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="CPM Aim değerini girin"
              min="0"
              step="0.01"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="border-t p-4 bg-gray-50">
          <div className="flex justify-between items-center">
            <div className="text-sm text-gray-600">
              {cpmAim ? `Mevcut: ${cpmAim}` : "Değer girilmemiş"}
            </div>
            <div className="flex gap-2">
              <button
                onClick={onClose}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
                disabled={isLoading}
              >
                İptal
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
                disabled={isLoading}
              >
                {isLoading ? "Kaydediliyor..." : "Kaydet"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CpmAimModal
